import { Box, Button, Flex, Heading, Input, InputGroup, SimpleGrid, Text } from '@chakra-ui/react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDebouncedFieldRegistry } from '@/utils/filterUtils/useDebouncedFieldRegistry';
import { ChakraFeatherIcon } from 'src/components/ChakraFeatherIcon';
import { RosterGroupFilters } from '../../types';
import { Club } from '@/model';
import TeamFilterSelect from '@/components/TeamFilterSelect';

export interface RosterGroupFilterBoxProps {
  clubs: Club[];
  filtersForm: UseFormReturn<RosterGroupFilters>;
  forceRefetch: () => void;
}

export const RosterGroupFilterBox = ({ clubs, filtersForm }: RosterGroupFilterBoxProps) => {
  const { t } = useTranslation();
  const { register, reset } = filtersForm;

  return (
    <Box>
      <Flex align='center' gap='pico' mb='deka'>
        <ChakraFeatherIcon color='text.main' name='filter' />
        <Heading variant='sectionTitle'>
          {t('pages.application_roster_group.components.roster_group_filter_box.roster_group_filter_box_title')}
        </Heading>
      </Flex>

      <Flex direction={{ base: 'row' }} gap='small' rowGap='micro'>
        <SimpleGrid
          gap='deka'
          alignItems='flex-end'
          columns={{ base: 1, sm: 2, md: 4, lg: 5, xl: 6 }}
          rowGap='xxsmall'
          flexGrow={1}
        >
          <TeamFilterSelect showFlag name='team_uuid' control={filtersForm.control} clubs={clubs} width='100%' />

          <InputGroup display='flex' flexDirection='column'>
            <Text fontWeight='medium'>
              {t('pages.application_roster_group.components.roster_group_filter_box.roster_group_filter_box_name')}
            </Text>
            <Input variant='flushed' {...useDebouncedFieldRegistry(() => register('name'))} />
          </InputGroup>
        </SimpleGrid>

        <Button alignSelf={{ lg: 'end' }} colorScheme='text' variant='outline' mt='10px' onClick={() => reset()}>
          {t('pages.application_roster_group.components.roster_group_filter_box.roster_group_filter_box_clear')}
        </Button>
      </Flex>
    </Box>
  );
};
